import { render, staticRenderFns } from "./AppEmbedLoader.vue?vue&type=template&id=1dccf248&scoped=true&"
import script from "./AppEmbedLoader.vue?vue&type=script&lang=js&"
export * from "./AppEmbedLoader.vue?vue&type=script&lang=js&"
import style0 from "./AppEmbedLoader.vue?vue&type=style&index=0&id=1dccf248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dccf248",
  null
  
)

export default component.exports